import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { Divider } from '@mui/material';
import { errorStyle } from './style';

type ErrorMessageProps = {
    message: string
};

const ErrorMessage = ({ message }: ErrorMessageProps):JSX.Element => (
  <>
    <Divider sx={ errorStyle.error.dividerError } />
    <Typography variant="caption" >
      <Box color={ errorStyle.error.color }
        sx={ errorStyle.error.sx }
      >
        { message }
      </Box>
    </Typography>
  </>
);

export default ErrorMessage;
